export default "__VITE_ASSET__KqnVbwGd__"